import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppLayoutModule } from "./layout/app.layout.module";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { initializeTheme } from "./app.theme.initializer";
import { ThemeService } from "./core/services/theme.service";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TenantIdInterceptor } from "./core/interceptors/tenant-id.interceptor";
import { DialogService } from "primeng/dynamicdialog";
import { AuthorizationInterceptor } from "./core/interceptors/authorization.interceptor";
import { UnauthorizedInterceptor } from "./core/interceptors/unauthorized.interceptor";
import { definePreset } from "@primeng/themes";
import Aura from "@primeng/themes/aura";
import { providePrimeNG } from "primeng/config";

const TwxThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#bed9e3",
      100: "#a6cdda",
      200: "#76b5cb",
      300: "#439ebd",
      400: "#2f7891",
      500: "#1d5163",
      600: "#174352",
      700: "#123541",
      800: "#0d2730",
      900: "#0a2129",
      950: "#0a2129",
    },
  },
});

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppLayoutModule,
    ConfirmDialogModule,
    ToastModule,
  ],
  providers: [
    MessageService,
    DialogService,
    provideAppInitializer(() => {
      const initializerFn = initializeTheme(inject(ThemeService));
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: TenantIdInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    providePrimeNG({
      theme: {
        preset: TwxThemePreset,
        options: {
          darkModeSelector: ".twx-dark-mode",
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
